import { CheckBoxOutlined } from '@mui/icons-material';
import { alpha } from '@mui/material';
import { Components, Theme } from '@mui/material/styles';

declare module '@mui/material/Checkbox' {
  interface CheckboxPropsSizeOverrides {
    large: true;
  }
}

export const muiCheckboxOverride: Components<Theme>['MuiCheckbox'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: 0,
      marginRight: theme.spacing(2),
      borderRadius: 5,
    }),
    colorPrimary: ({ theme }) => ({
      color: theme.vars.palette.grey[800],
      '&.Mui-checked': {
        color: theme.vars.palette.primary.main,
        backgroundColor: theme.vars.palette.common.white,
      },
      '&.Mui-disabled': {
        color: theme.vars.palette.grey[500],
      },
      '&:hover': {
        backgroundColor: theme.vars.palette.primary.light,
      },
    }),
    colorSecondary: ({ theme }) => ({
      color: theme.vars.palette.common.black,
      '&.Mui-checked': {
        backgroundColor: 'transparent',
        color: theme.vars.palette.common.black,
      },
      '&.Mui-disabled': {
        color: theme.vars.palette.grey[500],
      },
      '&:hover': {
        backgroundColor: alpha(theme.palette.grey[400], 0.2),
      },
    }),
  },
  defaultProps: {
    checkedIcon: <CheckBoxOutlined />,
  },
};
